//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import http from '@/fetch/http';
import util from '@/utils'
import axios from 'axios'
import {mapState, mapActions, mapGetters} from 'vuex';
import logoSrc  from '../assets/images/personal_info.png'
export default {
  data() {
    return {
      user: {
        name: "",
        nowPasswd: "",
        place: "dizhi",
        photo: "",
        school: "大连财经",
        phone: "131"
      },
      //保存按钮状态信息，1 亮起，2 新密码框格式错误 3 重复密码框格式错误
      saveFlag: '',
      //新密码
      newPasswd: '',
      //重复密码
      reNewPasswd: '',
      //侧边栏状态信息 true：显示 false: 关闭
      slideFlag: false,
      //当前密码
      passwd: '',
      isOnly: true,
      buttonColor: {
        'background-color': ''
      },
      icon_choose1: 'icon iconfont icon-xuanzhong2',
      icon_choose2: 'icon iconfont icon-xuanzhong2',
      iconInfo: [
        'icon iconfont icon-tanhao',
        'icon iconfont icon-xuanzhong3',
        'icon iconfont icon-xuanzhong2'
      ],
      msg1: '',
      msg2: '',
      msg3: '',
      btnColor: 'disabled',
      // 上传头像
      //新密码提示信息状态
      showFlag: false,
      //重复密码提示状态
      passwdFlag: false,
      //点确定首密码错误提示
      wrongPwdFlag: false,
      //学校区域信息
      schoolArea: '',
      //学校名称
      schoolName: '',
      img: 'img',
      inputFile: '',
      //uurl: '//192.168.1.161:9090/teach/userInfo/uploadBase64',
      uurl: 'http://192.168.1.143:8080/xufile/file/upload',
      imageSrc: ''
    }
  },
  computed: {
    ...mapState({
      headerPic: state => state.headerPic2,
      userInfo: state => state.user.userInfo,
    }),
    ...mapGetters({
      showLoading: 'showLoading'
    })
  },
  watch: {
    passwd: function () {
      if (this.passwd != '') {
        this.msg1 = '';
        this.wrongPwdFlag = false
      }
    },
    newPasswd: function () {
      if (this.newPasswd != '') {
        this.isOnly = false;
      }
      //新密码规则
      if (this.newPasswd.length > 20 || this.newPasswd.length < 6) {
        this.saveFlag = 0;
        this.icon_choose1 = this.iconInfo[0];
        this.btnColor = 'disabled';
      } else {
        this.msg2 = '';
        this.icon_choose1 = this.iconInfo[1];
        if (this.newPasswd == this.reNewPasswd) {
          this.btnColor = '';
        }
      }
    },
    reNewPasswd: function () {
      //重复输入密码规则
      if (this.reNewPasswd != this.newPasswd) {
        this.icon_choose2 = this.iconInfo[0];
        this.saveFlag = 2;
        this.btnColor = 'disabled';
      } else {
        this.msg3 = '';
        this.icon_choose2 = this.iconInfo[1];
        this.saveFlag = 1;
        if (this.passwd != '') {
          this.btnColor = '';
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setUserInfo: 'setUserInfo',
      setLoading: 'setLoading'
    }),
    showThumbPath(path){
      return util.showThumbPath(path, 'header');
    },
    uploadImage(event){
      var self = this;
      let formData = new FormData();
      formData.append("file", event.file);
      formData.append("chunk", 0);
      formData.append("chunks", 1);
      formData.append("fileName", event.file.name);
      formData.append("schoolId", this.userInfo.schoolId);
      formData.append("userId", this.userInfo.id);
      http.uploadFileOfResource(formData)
        .then(res => {
          if (res.status = "success") {
            let params = {
              userId: this.userInfo.id,
              path: res.data.path
            }
            http.saveHeadPortrait(params).then(result => {
              if (result.msgCode == 1) {
                self.imageSrc = res.data.path;
                self.userInfo.photo = res.data.path;
                self.setUserInfo(self.userInfo);
              }
            })
          }
        })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // flag 0 : 点击空白处|点击关闭侧边栏 1：修改密码  2.点击保存修改
    _showSlideBar(flag){
      if (flag == 0) {
        this.slideFlag = false;
      } else if (flag == 1) {
        this.passwd = '';
        this.newPasswd = '';
        this.reNewPasswd = '';
        this.msg1 = "",
          this.msg2 = "";
        this.msg3 = "",
          this.passwdFlag = false;
        this.showFlag = false;
        this.wrongPwdFlag = false;
        this.btnColor = 'disabled';
        this.slideFlag = true;
        //点击保存修改按钮
      } else if (flag == 2) {
        if (this.passwd == '') {
          this.msg1 = 'msg';
          return;
        }
        if (this.newPasswd.length > 20 || this.newPasswd.length < 6) {
          this.msg2 = 'msg';
          this.saveFlag = 2;
          this.icon_choose1 = this.iconInfo[0];
        }
        if (this.reNewPasswd != this.newPasswd) {
          this.msg3 = 'msg';
          this.icon_choose2 = this.iconInfo[0];
          this.saveFlag = 0;
        }
        if (this.saveFlag == 1) {
          if (this.newPasswd == this.reNewPasswd) {
            this.btnColor = '';
            //校验密码
            //当前用户名和旧密码
            let Data = {
              userName: this.userInfo.loginName,
              passwd: this.passwd
            }
            //重置的新密码
            let NewData = {
              id: this.userInfo.id,
              userName: this.userInfo.loginName,
              passwd: this.reNewPasswd
            }
            http.confirmPassWord(Data)
              .then(res => {
                if (res.msgCode == "1") {
                  http.resetPassWord(NewData).then(res => {
                    if (res.msgCode == "1") {
                      this.$toast({
                        message: "重置密码成功",
                        position: "bottom",
                        duration: 3000,
                        className: 'toastWhite'
                      })
                      this._closePage()
                    } else {
                      this.$toast({
                        message: "操作失败,请稍后重试！",
                        position: "bottom",
                        duration: 3000,
                        className: 'toastWhite'
                      })
                      this.newPasswd = "",
                        this.reNewPasswd = "",
                        this.msg1 = 'msg';
                      this.wrongPwdFlag = true,
                        this.passwdFlag = false,
                        this.showFlag = false
                    }
                  }).catch(res => {
                    this.$toast({
                      message: "操作失败,请稍后重试！",
                      position: "bottom",
                      duration: 3000,
                      className: 'toastWhite'
                    })
                    this.newPasswd = "",
                      this.reNewPasswd = "",
                      this.msg1 = 'msg';
                    this.wrongPwdFlag = true,
                      this.passwdFlag = false,
                      this.showFlag = false
                  })
                } else {
                  this.$toast({
                    message: "操作失败,请稍后重试！",
                    position: "bottom",
                    duration: 3000,
                    className: 'toastWhite'
                  })
                  this.newPasswd = "",
                    this.reNewPasswd = "",
                    this.msg1 = 'msg';
                  this.wrongPwdFlag = true,
                    this.passwdFlag = false,
                    this.showFlag = false
                  return;
                }
              })
              .catch(error => {
                this.$toast({
                  message: "操作失败,请稍后重试！",
                  position: "bottom",
                  duration: 3000,
                  className: 'toastWhite'
                })
              })
          } else {
            this.saveFlag = 0;
          }
        } else if (this.saveFlag == 0) {
          this.passwdFlag = true;
          this.showFlag = false;
        } else if (this.saveFlag == 2) {
          this.showFlag = true;
          this.passwdFlag = false;
        }
      }
    },
    _showHint(flag){
      if (flag == 0) {
        if (this.newPasswd == "") {
          this.icon_choose1 = this.iconInfo[2];
        }
        this.showFlag = true;
        this.passwdFlag = false;
      } else if (flag == 1) {
        if (this.newPasswd == "") {
          this.msg2 = 'msg';
          this.saveFlag = 0;
          this.icon_choose2 = this.iconInfo[2];
          this.passwdFlag = false;
          return;
        }
        if (this.reNewPasswd == "") {
          this.icon_choose2 = this.iconInfo[2];
        }
        this.passwdFlag = true;
        this.showFlag = false;
      } else if (flag == 3) {
        this.msg3 = "",
          this.passwdFlag = false;
        this.showFlag = false;
        this.wrongPwdFlag = false;
        this.msg2 = ""
      }
    },
    checkSchoolArea(schooleArea){
      if (schooleArea == null) {
        return '';
      }
      if (schooleArea.indexOf("null") != -1) {
        return schooleArea.replace("null", "");
      } else {
        return schooleArea;
      }
    },
    /**
     * 关闭当前页面
     * @private
     */
    _closePage(){
      this.$emit('closePage', false);
    },
  },
  created(){
    this.setLoading(0);
    this.imageSrc = this.userInfo.photo;
  }
}



// WEBPACK FOOTER //
// ./src/page/Personal.vue